import api from "./api";

export const usersService = {
  getAll() {
    return api.get("/users");
  },
  create(payload) {
    return api.post("/auth/register", payload);
  },
  update(id, payload) {
    return api.patch(`/users/${id}`, payload);
  },
  resetPassword(id, newPassword) {
    return api.post(`/users/${id}/reset-password`, { newPassword });
  },
  remove(id) {
    return api.delete(`/users/${id}`);
  },
};
